import {
  ADD_ROLE_REQUEST,
  DELETE_ROLE_REQUEST,
  EDIT_ROLE_REQUEST,
  GET_EDIT_ROLE_DATA_REQUEST,
  GET_EDIT_ROLE_DATA_RESPONSE,
  GET_MODULES_PERMISSIONS_REQUEST,
  GET_MODULES_PERMISSIONS_RESPONSE,
  ROLES_LIST_REQUEST,
  ROLES_LIST_RESPONSE,
  ROLE_DETAILS_REQUEST,
  ROLE_DETAILS_RESPONSE
} from "./types";

export const rolesListRequest = (payload) => ({
  type: ROLES_LIST_REQUEST,
  payload
});
export const rolesListResponse = (payload) => ({
  type: ROLES_LIST_RESPONSE,
  payload
});

export const getModulesPermissionsRequest = () => ({
  type: GET_MODULES_PERMISSIONS_REQUEST
});
export const getModulesPermissionsResponse = (payload) => ({
  type: GET_MODULES_PERMISSIONS_RESPONSE,
  payload
});

export const addRoleRequest = (payload) => ({
  type: ADD_ROLE_REQUEST,
  payload
});

export const getEditRoleDataRequest = (payload) => ({
  type: GET_EDIT_ROLE_DATA_REQUEST,
  payload
});
export const getEditRoleDataResponse = (payload) => ({
  type: GET_EDIT_ROLE_DATA_RESPONSE,
  payload
});

export const editRoleRequest = (payload) => ({
  type: EDIT_ROLE_REQUEST,
  payload
});
export const roleDetailsRequest = (payload) => ({
  type: ROLE_DETAILS_REQUEST,
  payload
});

export const roleDetailsResponse = (payload) => ({
  type: ROLE_DETAILS_RESPONSE,
  payload
});

export const deleteRoleRequest = (payload) => ({
  type: DELETE_ROLE_REQUEST,
  payload
});
